import { RouterProvider } from "react-router-dom";
import { AppPrivyProvider } from "@/app/privy-provider";
import { AuthProvider } from "@/features/auth/auth-provider";
import { E2eAuthProvider } from "@/features/auth/e2e-auth-provider";
import { ApiAuthBridge } from "@/features/auth/api-auth-bridge";
import { ToastProvider } from "@/components/design";
import { router } from "@/routes";

const isE2eAuth = import.meta.env.VITE_E2E_AUTH_BYPASS === "true";

export function App() {
  if (isE2eAuth) {
    return (
      <E2eAuthProvider>
        <ApiAuthBridge>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </ApiAuthBridge>
      </E2eAuthProvider>
    );
  }

  return (
    <AppPrivyProvider>
      <AuthProvider>
        <ApiAuthBridge>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </ApiAuthBridge>
      </AuthProvider>
    </AppPrivyProvider>
  );
}
